export const CAMPAIGN_EVALUATION_SESSION_KEY = 'campaign_evaluation_dismissed_session';

export const CAMPAIGN_EVALUATION_REWARD_ARTS = 5;

export function isCampaignEvaluationDismissedInSession() {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.sessionStorage.getItem(CAMPAIGN_EVALUATION_SESSION_KEY) === 'true';
}

export function dismissCampaignEvaluationForSession() {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(CAMPAIGN_EVALUATION_SESSION_KEY, 'true');
}
